/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmdk_Your_DocumentsInputs */

const en_cmdk_your_documents = /** @type {(inputs: Cmdk_Your_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your documents`)
};

const es_cmdk_your_documents = /** @type {(inputs: Cmdk_Your_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus documentos`)
};

/**
* | output |
* | --- |
* | "Your documents" |
*
* @param {Cmdk_Your_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cmdk_your_documents = /** @type {((inputs?: Cmdk_Your_DocumentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmdk_Your_DocumentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_cmdk_your_documents(inputs)
	return en_cmdk_your_documents(inputs)
});